import isEqual from 'lodash/isEqual';

export const getChangedFields = (initialObj = {}, newObj = {}) => {
  const changedFields = {};
  Object.keys(newObj).forEach((key) => {
    if (!isEqual(initialObj[key], newObj[key])) {
      changedFields[key] = newObj[key];
    }
  });
  return changedFields;
};

export const hasChanges = (initialObj = {}, newObj = {}) => {
  return Object.keys(getChangedFields(initialObj, newObj)).length > 0;
};
